// @react-functional

import React from 'react';
import { useModal } from '../../../components/modal/useModal';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { CommentariesModal } from './CommentariesModal';

type Props = {
  docId: string;
  source: string;
  trackingOnClick: string;
  trackingOnOpen: string;
};

export const useCommentariesModal = ({
  docId,
  source,
  trackingOnClick,
  trackingOnOpen,
}: Props) => {
  const { openModal } = useModal(
    (modalProps) => (
      <CommentariesModal
        docId={docId}
        source={source}
        trackingEventName={trackingOnClick}
        {...modalProps}
      />
    ),
    [docId],
  );
  return () => {
    doctrineAnalytics(trackingOnOpen, {
      source,
      docId,
    });
    openModal();
  };
};
